import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-activity-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.css']
})

export class TimeoutComponent implements OnInit, OnDestroy {
    public visible: boolean = false;
    public movedTime: any = Date.now();
    public interval: any = 1000;
    // Inactivity limit: 15 minutes (900000 ms)
    public timeoutLimit: any = 900000;
    // Absolute session duration limit: 1 hour (3600000 ms)
    public sessionLimit: any = 3600000;
    public countdownTimer: any = 30;
    hasUserBeenLoggedOutAlread: boolean = false;

    private timerSubscription: Subscription;

    constructor(private router: Router, private dialogRef: MatDialog) {}

    @HostListener('document:mousemove', ['$event'])
    @HostListener('document:click', ['$event'])
    @HostListener('document:keypress', ['$event'])
    @HostListener('document:scroll', ['$event'])
    @HostListener('document:touchstart', ['$event'])
    onUserActivity(e) {
        if (!this.visible) {
            this.movedTime = Date.now();
        }
    }

    ngOnInit() {
        console.log('triggered the timeout oninit page');
        this.hasUserBeenLoggedOutAlread = false;
        this.movedTime = Date.now();

        this.timerSubscription = interval(this.interval).pipe(
            takeWhile(() => localStorage.getItem('bearer') && localStorage.getItem('bearer').length > 0)
        ).subscribe(() => {
            this.checkSession();
        });
    }

    ngOnDestroy() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }

    checkSession() {
        // 1. Absolute session duration (OAuth token lifetime) check
        const loginTimeStr = localStorage.getItem('loginTime');
        if (loginTimeStr) {
            const loginTime = parseInt(loginTimeStr, 10);
            const elapsed = Date.now() - loginTime;
            if (elapsed >= this.sessionLimit) {
                console.log('Absolute session duration expired. Logging out.');
                this.logout();
                return;
            }
        }

        // 2. Inactivity check
        if (!this.visible) {
            const timeDiff = Date.now() - this.movedTime;
            if (timeDiff > this.timeoutLimit) {
                this.visible = true;
                this.countdownTimer = 30;
            }
        } else {
            // Modal is visible, countdown is active
            if (this.countdownTimer <= 0) {
                console.log('Inactivity warning expired. Logging out.');
                this.logout();
            } else {
                this.countdownTimer -= 1;
            }
        }
    }

    continue() {
        this.visible = false;
        this.movedTime = Date.now();
        this.countdownTimer = 30;
    }

    logout() {
        if (!this.hasUserBeenLoggedOutAlread) {
            console.log('timeout page logged you out');
            this.hasUserBeenLoggedOutAlread = true;

            localStorage.clear();

            this.visible = false;
            this.countdownTimer = 30;

            this.dialogRef.closeAll();
            
            this.router.navigateByUrl('login');
        }
    }

}
